export default "__VITE_ASSET__5457546b__"